import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import api from '../../../Auth/api'
import { updateModal } from '../../../components/ErrorModal'

/**
 * Кнопка получения файла счёта из 1С.
 *
 * При успешном запросе вызывает onSuccess, чтобы родительский виджет
 * разблокировал кнопку «Сохранить». При ошибке показывает сообщение бэкенда.
 */
export default function GetBillFrom1cButton({
  number,
  date,
  onSuccess,
  disabled = false
}) {
  const [loading, setLoading] = React.useState(false)

  const handleClick = React.useCallback(async () => {
    setLoading(true)
    try {
      await api.get('paid-service/task-get-bill-file', {
        params: { number, date },
        responseType: 'blob'
      })
      onSuccess()
    } catch (error) {
      const backendErrors = error.response?.data?.errors
      if (backendErrors?.length) {
        updateModal(backendErrors)
      } else {
        updateModal([{ message: 'Не удалось получить счёт из 1С' }])
      }
      console.error('Ошибка получения счёта из 1С:', error)
    } finally {
      setLoading(false)
    }
  }, [number, date, onSuccess])

  return (
    <Box>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={disabled || loading}
      >
        {loading ? 'Получение счёта из 1С...' : 'Получить счёт из 1С'}
      </Button>
    </Box>
  )
}
